import React from "react";
import { useSettings, logoUrl } from "../context/SettingsContext";
import { GraduationCap } from "lucide-react";

export default function Brand({ size = "md", showName = true }) {
  const { settings } = useSettings();
  const url = logoUrl(settings.logo_path);
  const dim = size === "lg" ? "h-12 w-12" : size === "sm" ? "h-8 w-8" : "h-10 w-10";
  return (
    <div className="flex items-center gap-3" data-testid="brand">
      <div
        className={`${dim} shrink-0 overflow-hidden rounded-xl flex items-center justify-center`}
        style={{ backgroundColor: url ? "transparent" : "var(--brand)" }}
      >
        {url ? (
          <img src={url} alt="logo" className="h-full w-full object-cover" data-testid="brand-logo" />
        ) : (
          <GraduationCap className="h-1/2 w-1/2 text-white" />
        )}
      </div>
      {showName && (
        <span className="font-heading font-semibold text-foreground leading-tight" data-testid="brand-name">
          {settings.school_name}
        </span>
      )}
    </div>
  );
}
